/* eslint-disable no-undef */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import store from './store'
// import FastClick from 'fastclick'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/less/reset.less'
import '@/assets/less/common.less'
import '@/assets/less/assembly.less'
import '@/assets/less/dynamic.less'
import '@/assets/css/icon.css'
import '@/assets/css/icon2.css'
import '@/assets/css/font-awesome.min.css'
import '@/assets/less/tips.less'
import '@/assets/js/common'
import VueLazyload from 'vue-lazyload'
import '@/assets/js/axiosInterceptors'
import tips from '@/components/base/tips'
import wait from '@/components/base/wait/index.js'
import pulldown from '@/components/base/pulldown'
import uploadTool from '@/components/base/uploadTool'
import share from '@/components/base/share'
import imageClipper from '@/components/base/imageClipper/index'
// import VuePreview from '@/components/tools/preview/index.js'
import { Alert, Confirm, Toast } from 'wc-messagebox'
import 'wc-messagebox/style.css'
import '@/assets/js/plusready'
import '@/assets/css/mui/mui.css'
import '@/assets/css/mui/preview.less'
import '@/assets/js/mui/mui.zoom'
import '@/assets/js/mui/mui.previewimage'
import '@/assets/js/push'
import '@/assets/js/vueTouch'
import '@/assets/js/vueDirect'
import socketIo from '@/assets/js/socketIo'
import { isEmptyObject } from '@/assets/js/util'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
// import bus from '@/assets/js/bus'

/**
 * 路由拦截器
 */
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (store.state.token && !isEmptyObject(store.state.user)) {  // 通过vuex state获取当前的token是否存在
      next()
    } else {
      next({
        path: '/login',
        query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next()
  }
})
Vue.use(ElementUI)
Vue.use(imageClipper)
Vue.use(tips)
Vue.use(wait)
Vue.use(pulldown)
Vue.use(uploadTool)
Vue.use(share)
Vue.prototype.$bus =  new Vue();
// FastClick.prototype.needsClick = function (target) {
//   switch (target.nodeName.toLowerCase()) {
//     // Don't send a synthetic click to disabled inputs (issue #62)
//     case 'button':
//     case 'select':
//     case 'input':
//       return true
//     case 'label':
//     case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
//     case 'video':
//       return true
//     case 'textarea':
//       return true
//   }
//   return (/\bneedsclick\b/).test(target.className)
// }
// FastClick.attach(document.body)
Vue.config.productionTip = false
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: './static/images/loading.png',
  attempt: 1
})
// Vue.use(VuePreview)
Vue.use(Alert, {})
Vue.use(Confirm, {})
Vue.use(Toast, {})
Vue.use(socketIo)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js